import { format } from 'date-fns'
import { DATE_TIME_FORMAT } from '../date-formatting.js'
import { transactionalApi } from '../http-client.js'

export const getSubmissionLogs = () => {
	return transactionalApi.get('audit').then(({ data: { hasPii, submissions } }) => JSON.parse(JSON.stringify(({
		data: {
			hasPii: hasPii,
			submissions: submissions.map(submission => ({
				submissionId: submission.submissionId,
				submissionType: submission.submissionType,
				submission: submission.submission,
				submissionDateTime: format(new Date(submission.submissionDateTime), DATE_TIME_FORMAT),
				limitedSubmission: submission.submission?.substring(0, 50) + ' ...'
			}))
		}
	}))))
}

export const getSubmissionFailures = () => {
	return transactionalApi.get('audit/SubmissionFailures').then(({ data: { hasPii, submissionFailures } }) => JSON.parse(JSON.stringify(({
		data: {
			hasPii: hasPii,
			submissionFailures: submissionFailures.map(submissionFailure => ({
				submissionId: submissionFailure.submissionId,
				submission: submissionFailure.submission,
				type: submissionFailure.type,
				failureType: submissionFailure.failureType,
				submissionDateTime: format(new Date(submissionFailure.submissionDateTime), DATE_TIME_FORMAT),
				limitedSubmission: submissionFailure.submission?.substring(0, 50) + (hasPii && submissionFailure.submission !== '' ? '  ...' : '')
			}))
		}
	}))))
}
export const getIntegrationFailures = (systemID, integrationID) => {
	const params = new URLSearchParams()
	if (systemID) params.append('systemID', systemID)
	if (integrationID) params.append('integrationID', integrationID)
	const queryString = params.toString() ? `?${params.toString()}` : ''

	return transactionalApi.get(`audit/GetIntegrationFailures${queryString}`).then(({ data: { hasPii, failures } }) => ({
		data: {
			hasPii,
			failures: failures.map(failure => ({
				failureID: failure.failureID,
				systemName: failure.systemName,
				integration: failure.integration,
				responseDate: format(new Date(failure.responseDate), DATE_TIME_FORMAT),
				responseCode: failure.responseCode,
				responseMessage: hasPii ? failure.responseMessage : '',
				limitedResponseMessage: hasPii && failure.responseMessage
					? failure.responseMessage.substring(0, 50) + ' ...'
					: ''
			}))
		}
	}))
}
